import Vue from "vue";
import App from "./App.vue";
import router from "./router";

import axios from "axios";

Vue.config.productionTip = false;

//axios.defaults.baseURL = "https://localhost:44306/api";
//axios.defaults.baseURL = "http://localhost/LTS.SingleLogin.API/api"; // Use this URL for testing on your local API
axios.defaults.baseURL = "https://ltsystems1.co.za/LoginBackend/api"; // Use this URL for production. Make sure it points to the backend/api as it is hosted on IIS
//axios.defaults.baseURL = "https://ltsystems1.co.za/LoginBackendTest/api"; // Use this URL for testing. Make sure it points to the backend/api as it is hosted on IIS
axios.defaults.headers.get["Accept"] = "application/json";
axios.defaults.headers.post["Accept"] = "application/json";
axios.defaults.headers["Pragma"] = "no-cache"; // If this is not added, then IE11 caches requests... Seriously IE11 sucks

new Vue({
  router,
  render: (h) => h(App)
}).$mount("#app");